import React from 'react';
import ReactDOM from 'react-dom';
import { mobileMenu } from './components/mobileMenu';
import { desktopMenu } from './components/desktopMenu';
import { parallax } from './components/parallax';
import { gforms } from './components/gforms';
import { gallery } from './components/gallery';
import { featuredWork } from './components/featuredWork';
import { processSlider } from './components/processSlider';
import { homeHero } from './components/homeHero';
import Portfolio from './portfolio';
import { servicesSlider } from './components/servicesSlider';
import { teamGrid } from './components/teamGrid';

// make $ global
!window.$ && (window.$ = jQuery);

$(() => {
  mobileMenu();
  desktopMenu();
  gforms();
  gallery();
  featuredWork();
  processSlider();
  servicesSlider();
  homeHero();
  teamGrid();
  parallax();

  // filters
  (async () => {
    const getItems = fetch(
      '/wp-json/wp/v2/work?per_page=100&_embed=wp:featuredmedia'
    ).then((d) => d.json());
    const getTypes = fetch('/wp-json/wp/v2/project_types?per_page=100').then(
      (d) => d.json()
    );
    const getIndustries = fetch('/wp-json/wp/v2/industries?per_page=100').then(
      (d) => d.json()
    );
    const [items, types, industries] = await Promise.all([
      getItems,
      getTypes,
      getIndustries,
    ]);

    const root = document.getElementById('portfolio');
    root &&
      ReactDOM.render(
        <Portfolio items={items} types={types} industries={industries} />,
        root
      );
  })();
});
